// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"332":"component---src-templates-index-js","523":"cb1608f2","749":"c9c6fe98"}[chunkId] || chunkId) + "-" + {"332":"26db6dd0fe25f5e8f847","523":"5211b04a1339d65568be","749":"cc0c06b5e219aa2ce8d0","954":"cbd70f273f207c396e7a"}[chunkId] + ".js";
};